@if (mode() == 'dialog') {
<mat-dialog-content class="mat-typography">
    <ng-container [ngTemplateOutlet]="appJsonViewer"></ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
}
@else {
<ng-container [ngTemplateOutlet]="appJsonViewer"></ng-container>
}


<ng-template #appJsonViewer let-element>

    <section class="app-json-viewer">
        @for (segment of segments; track $index) {
        <section [ngClass]="['segment', 'segment-type-' + segment.type]">
            <section (click)="toggle(segment)" [ngClass]="{
                'segment-main': true,
                'expandable': isExpandable(segment),
                'expanded': segment.expanded
                }">
                @if (isExpandable(segment)) {
                <div class="toggler">
                    <mat-icon>keyboard_arrow_right</mat-icon>
                </div>
                }
                <span class="segment-key">{{ segment.key }}</span>
                <span class="segment-separator">: </span>
                @if (!segment.expanded || !isExpandable(segment)) {
                <span class="segment-value">{{ segment.description }}</span>
                }
            </section>
            @if (segment.expanded && isExpandable(segment)) {
            <section class="children">
                <app-json-viewer [json]="segment.value" [expanded]="expanded()" [depth]="depth()"
                    [_currentDepth]="_currentDepth()+1"></app-json-viewer>
            </section>
            }
        </section>
        }
    </section>
</ng-template>